/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Toaster, toast} from "react-hot-toast";
import SchoolContext from "../../../Context/SchoolContext";
import StudentsRegisteredToday from "../../../Components/Students/AdminProfile/StudentsRegisteredToday";
import StudentContext from "../../../Context/StudentContext";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import AppContainer from "../../../Components/Structure/AppContainer";
import AuthumSearchForm from "../../../Components/Common/AuthumSearchForm";
import Loader from "../../../Components/Common/Loader";
import ConfirmAddStudent from "../../../Components/Students/AdminProfile/ConfirmAddStudent";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import AddMissingStudent from "../../../Components/Students/AdminProfile/AddMissingStudent";
import { Link } from "react-router-dom";

function SearchStudentsPage(props) {

    const [studentList, setStudentList] = useState(null);
    const {schoolList} = useContext(SchoolContext);
    const {studentsToday, getStudentsToday} = useContext(StudentContext);
    const [modal, setModal] = useStateCallback(false);

    const [school, setSchool] = useState("");
    const [studentName, setStudentName] = useState("");
    const [loading, setLoading] = useState(false)

    const searchAuthumStudent = async () => {
        if (school.length> 0 && studentName.length >= 4) {
            setLoading(true)
            const server_response = await ajaxStudent.searchAuthumStudent(studentName, school);
            setLoading(false)
            if (server_response.status === "OK") {
                setStudentList(server_response.details);
            } else {
                setStudentList(false);
            }
        }
        else{
          toast.error("Please select school and enter at least 4 characters for better results!");  
        }
    };

    const setStudents = (e) => {
    e.preventDefault();
    setStudentList(null);
    
  };

  const handleAdd=(e,item)=>{
    setModal(false, ()=>setModal(<ConfirmAddStudent studentName={item.full_name} firstName={item.first_name} lastName={item.surname} 
        gender={item.gender} schoolCode={item.school_code} regNo={item.reg_no} authumID={item.id} className={item.class_name}
        g={getStudentsToday} isOpen={true}/>))
  }

  const handleModal = () => {
      setModal(false, () =>
        setModal(
          <AddMissingStudent
          schoolID={school}
            g={getStudentsToday}
            isOpen={true}
          />
        )
      );
    };

    useEffect(() => {
        getStudentsToday();
    }, []);

    return (
        <AppContainer title="Add Student">
            <Toaster position="top-center" reverseOrder={false} />
            {modal}
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="card custom-card" style={{ borderRadius: "10px" }}>
                        <div className="card-body">
                            <div>
                                <h5 style={{ marginBottom: 0 }} className="card-title">
                                Student Search
                                </h5>
                                <p style={{ color: "#042954" }}>
                                  <small>Please enter a student's name to search.<br/>If a match is found, click the green "Register" button on the right. If no match is found, you can add a new student.</small>
                                </p>
                                
                            </div>
                            <AuthumSearchForm school={school} student={studentName} setSchool={setSchool} setStudent={setStudentName}
                            searchStudents={searchAuthumStudent} resetSearch={setStudents} schoolList={schoolList}/>
                        </div> 
                    </div>
                </div>

                <div className="col-lg-12 col-md-12">
                  {loading &&  (
                      <div className="card custom-card" style={{ borderRadius: "10px" }}>
                        <div className="card-body">
                          <div style={{ textAlign: "center" }}>
                            <Loader />
                          </div>
                        </div>
                      </div>
                    )}
                          {studentList === false && (
                            <div className="card custom-card" style={{ borderRadius: "10px" }}>
                              <div className="card-body">
                                <div>
                                  <p style={{ textAlign: "center" }}>
                                    No matching students found.<br/> <Link onClick={handleModal} className="btn btn-primary mr-3"><i className="far fa-plus mr-1"></i>Add New Student</Link>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                          {studentList && ( // Show the student info if numberSearch is true
                            <div className="card custom-card" style={{ borderRadius: "10px" }}>
                              <div className="card-body">
                                <div>
                                    <h5 style={{ marginBottom: 0 }} className="card-title">
                                    Student Suggestions
                                    </h5>
                                </div>
                                <div className="table-responsive">
                                    {loading ? (
                                        <Loader />
                                    ) : (
                                        <table className="table display data-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Name</th>
                                            <th>Gender</th>
                                            <th>Class Name</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {studentList.length > 0 ? (
                                            studentList.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{width:"5px"}}>{index + 1}</td>
                                                <td>{item.full_name}</td>
                                                <td className="text-dark">{item.gender}</td>
                                                <td className="text-dark">{item.class_name}</td>
                                                <td> <Link onClick={(e) => handleAdd(e,item)} className="btn btn-success mr-3"><i className="far fa-plus mr-1"></i>Register</Link></td>
                                               
                                            </tr>
                                            ))
                                        ) : 
                                        (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No students registered yet.
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                        </table>
                                    )}
                                    {studentList.length > 0 && studentList.length < 8 && (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <p>Still didn't find the student you're looking for?
            <Link onClick={handleModal} className="btn btn-primary ml-2">
              <i className="far fa-plus mr-1"></i> Add New Student
            </Link></p>
          </div>
        )}
                                  
                                </div></div>
                             
                            </div>
                          )}
                          
                        </div>
                 
            </div>

            <StudentsRegisteredToday studentsToday={studentsToday} adminType="admin"/>
        
        </AppContainer>
    );
}

export default SearchStudentsPage;
